import { Events } from 'phaser';
import type { TrainHudState } from './scenes/TrainAdventureScene';
import type { FinishPlayAttemptInput } from '../../shared/results';

export const EventBus = new Events.EventEmitter();

export const TRAIN_HUD_UPDATE_EVENT = 'train-hud-update';
export const TRAIN_GAME_FINISHED_EVENT = 'train-game-finished';
export const ROUTE_HUD_UPDATE_EVENT = 'route:hud-update';
export const ROUTE_GAME_FINISHED_EVENT = 'route:game-finished';
export const BRIDGE_HUD_UPDATE_EVENT = 'bridge:hud-update';
export const BRIDGE_GAME_FINISHED_EVENT = 'bridge:game-finished';
export const RACE_HUD_UPDATE_EVENT = 'race:hud-update';
export const RACE_GAME_FINISHED_EVENT = 'race:game-finished';
export const BALANCE_HUD_UPDATE_EVENT = 'balance:hud-update';
export const BALANCE_GAME_FINISHED_EVENT = 'balance:game-finished';
export const SPECTACLE_ENTRANCE_EVENT = 'spectacle:entrance';
export const SPECTACLE_ACTION_EVENT = 'spectacle:action';
export const SPECTACLE_HIT_EVENT = 'spectacle:hit';

export type TrainHudUpdate = {
  gameId: string;
  hud: TrainHudState;
};

export type TrainGameResult = {
  gameId: string;
  result: FinishPlayAttemptInput;
};

export type RouteHudState = {
  level: number;
  totalLevels: number;
  question: string;
  questionMediaUrl?: string;
  phase: 'overview' | 'playing' | 'transitioning' | 'won' | 'lost';
  score: number;
  lives: number;
  /** Alevli Rota: Normal modda can gösterilmez. */
  mode?: 'guided' | 'challenge';
};

export type RouteHudUpdate = { gameId: string; hud: RouteHudState };
export type RouteGameResult = { gameId: string; result: FinishPlayAttemptInput };

export type BridgeHudState = {
  question: number;
  totalQuestions: number;
  phase: 'intro' | 'awaiting-answer' | 'feedback' | 'bridge-building' | 'awaiting-drive' | 'rover-crossing' | 'camera-travel' | 'finished' | 'game-over';
  mode: 'guided' | 'challenge';
  score: number;
  lives: number;
  remainingMs: number | null;
};
export type BridgeHudUpdate = { gameId: string; hud: BridgeHudState };
export type BridgeGameResult = { gameId: string; result: FinishPlayAttemptInput };

export type RaceHudState = {
  question: number;
  totalQuestions: number;
  phase: 'vehicle-select' | 'countdown' | 'racing' | 'feedback' | 'finish';
  score: number;
  place: 1 | 2 | 3;
  streak: number;
  remainingMs: number | null;
};
export type RaceHudUpdate = { gameId: string; hud: RaceHudState };
export type RaceGameResult = { gameId: string; result: FinishPlayAttemptInput };

export type BalanceHudState = {
  question: number;
  totalQuestions: number;
  phase: 'intro' | 'playing' | 'feedback' | 'finished' | 'fallen';
  score: number;
  wind: -1 | 1;
  /** Düşene kadar tekrar modu: tur, verilen cevap sayısı ve dayanma süresi. */
  repeat?: { round: number; answered: number; survivalMs: number };
};
export type BalanceHudUpdate = { gameId: string; hud: BalanceHudState };
export type BalanceGameResult = { gameId: string; result: FinishPlayAttemptInput };
